<template>
  <div class="radio">
    <label
      class="radio__body"
      v-for="option in options"
      :key="option.value"
      @click="changeValue(option)"
    >
      <input
        type="radio"
        :checked="currentValue === option.value"
        :name="name"
      />
      <i class="radio__button"></i>
      <span class="radio__label">{{ option.label }}</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "CRadio",
  props: ["options", "defaultValue", "name"],
  data() {
    return {
      currentValue: this.defaultValue
    };
  },
  methods: {
    changeValue(option) {
      this.$emit("input", option.value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.radio {
  display: flex;
  @media #{$mobile} {
    flex-direction: column;
  }
  input {
    display: none;
  }
  &__body {
    display: flex;
    align-items: center;
    cursor: pointer;
    @media #{$mobile} {
      margin-bottom: 25px;
    }
  }
  &__button {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    border: 2px solid #cccccc;
    background: #ffffff;
    display: block;
    transition: border 200ms ease;
    margin-right: 10px;
    input:checked + & {
      border: 5px solid #3a5eec;
    }
  }
  &__label {
    margin-right: 44px;
    white-space: nowrap;
  }
}
</style>
